import React, { useState } from "react";
import user from "../assets/images/user.png";
import fb from "../assets/icons/facebook.svg"
import insta from "../assets/icons/insta.svg";
import yt from "../assets/icons/YT.svg";
import { useRedirect } from "../hooks/useRedirect";
import pathnames from "../routes/index.route";
import checkbox from "../assets/icons/radio_button_check.svg";
import nCheck from "../assets/icons/RadioNonCheckedIcon.svg";
import { ArrowReturnRight, ThreeDotsIcon, TranslateIcon } from "../assets/icons/Icons";

const AccountGroupCard = ({ width, className, check = false }: { width?: string; className?: string, check?: boolean }) => {
  const [selected, setSelected] = useState<boolean>(false);
  const redirect = useRedirect();
  return (
    <div onClick={() => redirect(pathnames.accounts+pathnames.specificGroup)} className={`${width ? `w-[${width}]` : "w-[379px]"} h-[94px] bg-white rounded-xl p-3 ${className} cursor-pointer`}>
      <div className="flex items-center gap-[10px]">
        <img src={user} className="w-10 h-10 rounded-full" alt="user" />
        <div className="w-full">
          <div className="flex justify-between">
            <h1 className="text-[#0F0C18] text-base font-medium tracking-tight">Andrew Wack</h1>
            {
            !check ?
              <ThreeDotsIcon />
              :
              selected ? <img onClick={() => setSelected(false)} src={checkbox} className="cursor-pointer w-4 h-4" alt="check" /> :
              <img onClick={() => setSelected(true)} src={nCheck} className="cursor-pointer w-4 h-4" alt="check" />
          }
          </div>
          <div className="flex items-center justify-between">
            <p className="text-[#9392A2] text-xs font-medium tracking-tight">3 accounts under</p>
            <p className="text-[#9392A2] text-base font-medium leading-none tracking-tight">134,4k</p>
          </div>
        </div>
      </div>
      <div className="ml-3 mt-3 flex items-center justify-between">
        <div className="flex items-center gap-[22px]">
          <ArrowReturnRight />
          <div className="flex items-center gap-1">
            <div className="flex items-center">
              <img src={fb} className="w-4 h-4 rounded-full mr-[-5px]" alt="fb" />
              <img src={insta} className="w-4 h-4 rounded-full mr-[-5px]" alt="insta" />
              <img src={yt} className="w-4 h-4 rounded-full" alt="yt" />
            </div>
            <p className="text-[#9392A2] text-xs font-medium tracking-tight">3 social networks</p>
          </div>
        </div>
        <div className="flex items-center gap-[7px]">
          <TranslateIcon />
          <p className="text-[#9392A2] text-xs font-medium tracking-tight">2 languages</p>
        </div>
      </div>
    </div>
  );
};

export default AccountGroupCard;